import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const WeddingsPage: React.FC = () => {
  return <EventPageTemplate {...eventData.weddings} />;
};

export default WeddingsPage;